// @flow
export const APP_INSTALL_BANNER_CLOSE = 'APP_INSTALL_BANNER_CLOSE';
export const APP_INSTALL_BANNER_OPEN = 'APP_INSTALL_BANNER_OPEN';
export const WAG_TAG_CTA_CLICKED = 'WAG_TAG_CTA_CLICKED';
export const WAG_TAG_PAGE_MOUNTED = 'WAG_TAG_PAGE_MOUNTED';
export const WAG_TAG_FORM_SUBMITTED = 'WAG_TAG_FORM_SUBMITTED';

export type TrackingEvent = typeof WAG_TAG_CTA_CLICKED
| typeof WAG_TAG_PAGE_MOUNTED
| typeof WAG_TAG_FORM_SUBMITTED
| typeof APP_INSTALL_BANNER_CLOSE
| typeof APP_INSTALL_BANNER_OPEN;
